import { render } from "./Unauthorized.vue?vue&type=template&id=24e04d30&scoped=true"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"

import "./Unauthorized.vue?vue&type=style&index=0&id=24e04d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e04d30"]])

export default __exports__